<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-hover">
      <thead>
        <tr>
          <th class="text-lefth">#</th>
          <th class="text-lefth">Nombre de Cupón</th>
          <th class="text-lefth">Fecha inicio</th>
          <th class="text-lefth">Fecha Fin</th>
          <th class="text-lefth">Cantidad de cupones</th>
          <th class="text-lefth">Cantidad maxima de cupones</th>
          <th class="text-lefth">cantidad de cupones por cada</th>
          <th class="text-lefth">Cantidad de Q minima de factura</th>
          <th class="text-lefth">Estatus</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="
            irAEsconderModal('pos-cuponera-editar', {
              id: current.id,
            })
          "
        >
          <td>{{ current.id }}</td>
          <td>{{ current.nombre }}</td>
          <td>{{ current.fecha_inicio }}</td>
          <td>{{ current.fecha_fin }}</td>
          <td>{{ current.cant_cupones }}</td>
          <td>{{ current.cant_maxima_cupones }}</td>
          <td>Q{{ current.por_cada }}</td>
          <td>Q{{ current.minimo_de_factura }}</td>
          <td>
            <span class="badge badge-success" v-if="current.estatus == true"
              >Activo</span
            ><span class="badge badge-danger" v-if="current.estatus == false"
              >Inactivo</span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() {},
  methods: {
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
